import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms'

import { SHORT_NUMBER_SUFFIXES } from '../constants/common.constant'

const regex = /^([\d.]+)([KMBTkmbt])?$/i

export function quickBetValueValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const formArray = control as FormArray
		const errors: ValidationErrors = {}

		if (!formArray || formArray.length === 0) {
			return null // No validation if the FormArray is empty
		}

		const controls = formArray.controls

		controls.forEach((currentControl) => {
			if (currentControl.value) {
				// Check for forbidden characters
				if (!regex.test(currentControl.value)) {
					errors['forbiddenCharactersUsed'] = true
				}

				const currentValue = getNumericValue(currentControl.value)
				// Check against the left neighbor for strict inequality
				if (currentValue <= 0) {
					errors['lessThanZero'] = true
				}

				// Apply errors to the current control if there are any, otherwise clear errors
				if (Object.keys(errors).length > 0) {
					currentControl.setErrors(errors)
				} else {
					currentControl.setErrors(null)
				}
			}
		})

		return errors // Valid
	}
}

/**
 * Return the numerical value of a short number representation
 * @param value
 */
function getNumericValue(value: string | number): number {
	const match = regex.exec(value.toString())

	if (!match) {
		if (!isNaN(+value)) {
			// If the input is already a number, return it as-is
			return +value
		} else {
			return NaN
		}
	}

	const numericValue = parseFloat(match[1])
	const suffix = match[2]?.toUpperCase()

	if (!suffix) {
		// No suffix means it's a plain number
		return numericValue
	}

	const chosenSuffix = SHORT_NUMBER_SUFFIXES.find((record) => record.suffix === suffix)
	if (!chosenSuffix) {
		throw new Error(`Unknown suffix: ${suffix}`)
	}

	return numericValue * chosenSuffix.value
}
